// extracted by mini-css-extract-plugin
export default {"rowWrapper":"InfoRow_rowWrapper__-BPNJ"};